import { createContext } from 'react';

import { PolicyExternalLinks } from '@src/pages/policies/show/components/policy-external-links.type';

export const PolicyExternalLinksContext =
  createContext<PolicyExternalLinks>(null);
